import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

export const NONE_SUBMIT = 0;
export const PARTIAL_SUBMIT = 1;
export const ALL_SUBMIT = 2;

class CheckboxRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const {
      value, data, disabled,
      isSelected, isValid,
    } = this.props;
    if (!data) {
      return null;
    }
    if (value === null || data.contactStatus === 'loading') {
      return (<Fa name="spinner" spin className="text-muted" />);
    }

    let message = null;
    if (value === PARTIAL_SUBMIT) {
      message = 'Some contacts have been submitted';
    } else if (value === ALL_SUBMIT) {
      message = 'All available contacts have been submitted';
    }
    
    const fontSize = '1.2em';
    const textColor = isValid ? 'text-success' : 'text-danger';
    let cls = isSelected ? textColor : 'text-muted';

    let iconName = isSelected ? 'check-square' : 'square-o';
    if (value === PARTIAL_SUBMIT) {
      iconName = isSelected ? 'check-square' : 'minus-square';
    } else if (value === ALL_SUBMIT) {
      iconName = 'check-square';
      cls = 'text-muted';
    }
    if (isSelected && !isValid) {
      message = 'Please select at least one contact and one Truvoice product';
    }
    const hasMessage = message && message.length > 0;
    const tooltip = hasMessage ? <Tooltip id={`${data._id}_tooltip`}>{message}</Tooltip> : null;

    const cursor = disabled || value === ALL_SUBMIT ? 'not-allowed' : 'pointer';

    const icon = (
      <Fa
        name={iconName}
        style={{ fontSize }}
        className={cls}
      />
    );

    return (
      <div style={{ cursor }}>
        {hasMessage &&
          <OverlayTrigger placement="right" overlay={tooltip}>
            {icon}
          </OverlayTrigger>
        }
        {!hasMessage && icon}
      </div>
    );
  }
}


CheckboxRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    contactStatus: PropTypes.string,
  }),
  value: PropTypes.number,
  disabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  isValid: PropTypes.bool,
};
CheckboxRenderer.defaultProps = {
  data: null,
  value: null,
  disabled: false,
  isSelected: false,
  isValid: false,
};
export default CheckboxRenderer;
